import UserTypeCard from "./UserTypeCard";
export default UserTypeCard;
